module.exports = __webpack_public_path__ + "img/trade_mobdia.png";